<template>
  <div v-if="showSection" class="description">
    <h3 class="pb-4 pt-3 font-size-xxxl">
      {{ manufacturer.maker_name }}
    </h3>
    <div class="v-row description-text flex-column-reverse flex-sm-row">
      <div class="v-col-12 v-col-sm-8 v-col-xl-7">
        <p class="pt-0 styled-text">{{ manufacturer.maker_description }}</p>
      </div>
      <div class="v-col-12 v-col-sm-4 v-col-xl-5 px-5 px-sm-3 text-center">
        <img
          class="lozad pb-4 pb-sm-0"
          :alt="manufacturer.maker_name"
          :src="calculated.makerImage"
          :data-src="calculated.makerImage"
        />
      </div>
    </div>
    <div class="divider my-2"></div>
    <div class="mb-0 mt-3 styled-text">
      <div class="mb-4">{{ manufacturer.maker_reason_why_one }}</div>
      <div>{{ manufacturer.maker_reason_why_two }}</div>
    </div>
  </div>
</template>

<script>
import { usePdpStore } from '@/stores/pdp'
import { mapActions, mapState } from 'pinia'
import { useManufacturerStore } from '../../../stores/manufacturer.js'
export default {
  name: 'WineMakerDescription',
  props: {
    manufacturerId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState(usePdpStore, { product: 'getApiProduct' }),
    ...mapState(useManufacturerStore, ['manufacturer', 'calculated']),
    showSection() {
      return this.calculated?.makerImage && this.manufacturer?.maker_description
    }
  },
  methods: {
    ...mapActions(useManufacturerStore, ['fetchManufacturer'])
  },
  // mounted, not created: created also runs during a server render, where it
  // would start a floating fetch whose result never makes it into the
  // response (VIP-12038)
  mounted() {
    this.fetchManufacturer(this.manufacturerId)
  }
}
</script>

<style scoped>
img {
  max-width: 100%;
}
</style>
